// extracted by mini-css-extract-plugin
export default {"PhotoModel":"PhotoModel_PhotoModel__j5bMH"};